var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.333 3.52v1.6H8L7.666 8H5.333v8H1.667V8H0V5.12h1.667v-1.6S1.367.48 4.334 0H8v2.561H6.333s-.933-.033-1 .96","fill":"#041E42","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"width":"8","height":"16"};

module.exports = Facebook;

Facebook.default = Facebook;
